import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("authToken"); // Check if the user is authenticated

  // If the user is authenticated, redirect to the default protected route
  return token ? <Navigate to="/actual-sales" replace /> : children;
};

export default PublicRoute;